import React, { Component, Fragment } from 'react';
import Formnvoserver from "./Formnvoserver";
import Sidebar from "../navigation/Sidebar";
import Rest from "../../services/Rest";
import { withRouter } from "react-router-dom";

const initialState = {
    servidor: {
        nombre: "",
        estado: "",
        habilitado: false,
        ip: ""
    },
    error: false,
    success: false,
    message: ""
}
class Editserver extends Component {

    state = { ...initialState }

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        this.id_servidor = this.props.match.params.id;
    }

    componentDidMount() {
        if (this.id_servidor) {
            this.Rest.get("servidores/" + this.id_servidor, this.datauser)
                .then(response => {
                    if (response.status === 200) {
                        this.setState({
                            servidor: response.data[0]
                        })
                        if (response.data[0].estado === "1") {
                            this.setState({
                                servidor: {
                                    ...this.state.servidor,
                                    habilitado: true
                                }
                            })
                        }
                    }
                    else {
                        if (response.status === 404) {
                            localStorage.removeItem('ls');
                            window.location = window.location.origin;
                        }
                        else {
                            this.setState({
                                error: true,
                                message: response.message
                            })
                        }
                    }
                })
                .catch(err => {
                    this.setState({
                        error: true,
                        message: JSON.stringify(err)
                    })
                })
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { nombre, ip } = this.state.servidor;

        if (nombre === "") {
            this.setState({
                error: true,
                message: "El nombre del servidor es requerido"
            });
            return;
        }
        if (ip === "") {
            this.setState({
                error: true,
                message: "La IP del servidor es requerida."
            });
            return;
        }
        this.editarServidor();
    }

    editarServidor() {
        this.setState({
            error: false,
            message: ""
        })
        this.Rest.post(this.state.servidor, "servidores/actualizar", "servidor", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        success: true,
                        message: "Servidor actualizado"
                    }, () => {

                        this.props.history.push("/servidores");
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            message: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    message: JSON.stringify(err)
                })
            })
    }

    handleChange = (e) => {

        this.setState({
            servidor: {
                ...this.state.servidor,
                [e.target.name]: e.target.value
            }
        })

    }

    handleCheck = (e) => {
        if (this.state.servidor.habilitado) {
            this.setState({
                servidor: {
                    ...this.state.servidor,
                    estado: 0,
                    habilitado: false
                }
            })
        }
        else {
            this.setState({
                servidor: {
                    ...this.state.servidor,
                    estado: 1,
                    habilitado: true
                }
            })
        }
    }

    render() {
        const { error, message, success } = this.state
        return (
            <Fragment>
                {error ? <div className="alert alert-danger alert-float">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <b>{message}</b></div> : null}
                {success ? <div className="alert alert-success alert-float">
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <b>{message}</b></div> : null}
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="dashboard-panel">
                                <h4 className="mb-center">Editar servidor</h4>
                                <Formnvoserver
                                    dataState={this.state.servidor}
                                    handleSubmit={() => this.handleSubmit}
                                    handleChange={() => this.handleChange}
                                    handleCheck={() => this.handleCheck}
                                    habilitado={this.state.servidor.habilitado} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Editserver);


// WEBPACK FOOTER //
// ./src/components/servers/Editserver.js